import { useTranslations } from "@zapier/i18n";
import { useState, useEffect } from "react";
import { Key, Select, SelectItem } from "@zapier/design-system";
import { useAccountActionPermissions } from "@zapier/client";
import { Icon } from "@zapier/zinnia-icons";
import { useRouterParams } from "@zapier/shared";
import styles from "./SharingFilter.module.css";

export function SharingFilter() {
  const t = useTranslations("chatbots-sharing-filter");

  const { shared, setParams } = useRouterParams();
  const [selected, setSelected] = useState<string>("all");
  const { isSharingEnabled } = useAccountActionPermissions();

  useEffect(() => {
    setSelected(shared || "all");
  }, [shared]);

  const valueChange = (value: Key | null) => {
    const finalValue = (value as string) || "all";
    setSelected(finalValue);

    const omit: string[] = [];
    if (finalValue === "me") {
      omit.push("owner");
    }

    // for all other chatbots, add an ?owner param to the URL
    setParams({ shared: finalValue, page: 1 }, omit);
  };

  return (
    <div className={styles.root} data-testid="chatbots-sharing-filter">
      <Select
        label={t("label")}
        isLabelHidden={true}
        placeholder={t("placeholder")}
        onChange={valueChange}
        selectedKey={selected}
        size="medium"
      >
        <SelectItem value="all" textValue={t("options.all-chatbots")}>
          {t("options.all-chatbots")}
        </SelectItem>
        <SelectItem value="me" textValue={t("options.owned-by-me")}>
          {t("options.owned-by-me")}
        </SelectItem>
        <SelectItem value="-me" textValue={t("options.shared-with-me")}>
          <span className={styles.shared}>
            {t("options.shared-with-me")}{" "}
            {!isSharingEnabled && (
              <span data-testid="lock-icon">
                <Icon color="GrayWarm6" size="20" name="actionLock" />
              </span>
            )}
          </span>
        </SelectItem>
      </Select>
    </div>
  );
}
